// export const generateDataForTree = (data) => {
//   const { addresses = [], houses = [], serviceCompanyIds = [] } = data || {};

//   const companyIds = new Map();
//   const houseIds = new Map();
//   const addressIds = new Set();
//   const checkedKeys = new Set();
//   const halfCheckedKeys = new Set();

//   serviceCompanyIds.forEach((companyId) => {
//     companyIds.set(companyId, new Map());
//     checkedKeys.add(`${companyId}`);
//   });

//   houses.forEach(({ houseId, serviceCompanyId }) => {
//     const houses = companyIds.get(serviceCompanyId) || new Map();
//     houses.set(houseId, new Set());
//     companyIds.set(serviceCompanyId, houses);

//     houseIds.set(houseId, new Set());

//     checkedKeys.add(`${serviceCompanyId}-${houseId}`);
//     halfCheckedKeys.add(`${serviceCompanyId}`);
//   });

//   addresses.forEach(({ addressId, houseId, serviceCompanyId }) => {
//     const houses = companyIds.get(serviceCompanyId) || new Map();
//     const addresses = houses.get(houseId) || new Set();
//     addresses.add(addressId);
//     houses.set(houseId, addresses);
//     companyIds.set(serviceCompanyId, houses);

//     const houseIdsAddresses = houseIds.get(houseId) || new Set();
//     houseIdsAddresses.add(addressId);
//     houseIds.set(houseId, houseIdsAddresses);

//     addressIds.add(addressId);

//     checkedKeys.add(`${serviceCompanyId}-${houseId}-${addressId}`);
//     halfCheckedKeys.add(`${serviceCompanyId}`);
//     halfCheckedKeys.add(`${serviceCompanyId}-${houseId}`);
//   });

//   return {
//     companyIds,
//     houseIds,
//     addressIds,
//     checkedKeys: Array.from(checkedKeys),
//     halfCheckedKeys: Array.from(halfCheckedKeys),
//   };
// };

export const generateDataForTree = (data, serviceId, flats = {}) => {
  const {
    serviceCompany,
    houseIds: houses = [],
    addressIds: addresses = [],
  } = data?.alertAddresses || {};

  const serviceCompanyId = serviceCompany?.id || serviceId;

  const companyIds = new Map();
  const houseIds = new Map();
  const addressIds = new Set();
  const checkedKeys = new Set();
  const halfCheckedKeys = new Set();

  if (serviceCompanyId) {
    companyIds.set(serviceCompanyId, new Map());
    if (!houses.length && !addresses.length) {
      checkedKeys.add(`${serviceCompanyId}`);
    }
  }

  houses.forEach((houseId) => {
    const companyHouses = companyIds.get(serviceCompanyId) || new Map();
    companyHouses.set(houseId, new Set());
    companyIds.set(serviceCompanyId, companyHouses);

    houseIds.set(houseId, new Set());

    checkedKeys.add(`${serviceCompanyId}-${houseId}`);
    halfCheckedKeys.add(`${serviceCompanyId}`);
  });

  addresses.forEach((addressId) => {
    const addressToHouseMap = Object.entries(flats).reduce(
      (acc, [houseId, addressIds]) => {
        addressIds.forEach((addressId) => {
          acc[addressId] = Number(houseId);
        });
        return acc;
      },
      {}
    );

    const houseId = addressToHouseMap[addressId];

    const companyHouses = companyIds.get(serviceCompanyId) || new Map();
    const houseAddresses = companyHouses.get(houseId) || new Set();

    houseAddresses.add(addressId);
    companyHouses.set(houseId, houseAddresses);
    companyIds.set(serviceCompanyId, companyHouses);

    const houseIdsAddresses = houseIds.get(houseId) || new Set();
    houseIdsAddresses.add(addressId);
    houseIds.set(houseId, houseIdsAddresses);

    addressIds.add(addressId);

    checkedKeys.add(`${serviceCompanyId}-${houseId}-${addressId}`);
    halfCheckedKeys.add(`${serviceCompanyId}`);
    halfCheckedKeys.add(`${serviceCompanyId}-${houseId}`);
  });

  return {
    companyIds,
    houseIds,
    addressIds,
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(halfCheckedKeys),
  };
};
